import type { Document } from "@ctrl/controller-rpc";

export function isPromptDocumentEmpty(
  document: Document | null | undefined
): boolean {
  const blocks = document?.blocks;
  if (!blocks || blocks.length === 0) return true;
  if (blocks.length !== 1) return false;

  const block = blocks[0];
  if (!block) return true;

  return block.type === "paragraph" && block.content.trim() === "";
}
